module.exports = __webpack_public_path__ + "img/appQrcode_uat.45e44370.jpg";